import { Box, Button } from '@hover/blueprint';
import React from 'react';
import { useLocation } from 'react-router';

import { signupPaths } from 'src/shared/components/NavBar/StyledNavBar';
import { Route } from 'src/shared/route';

import { useHomeownerTranslate } from '../../hooks';
import { CobrandLogo } from '../CobrandLogo/CobrandLogo';

export const CobrandedHeader = () => {
  const { pathname, search } = useLocation();
  const t = useHomeownerTranslate();
  const isSignup = signupPaths.includes(pathname);

  return (
    <Box
      flexDirection={isSignup ? 'row' : { base: 'column', tablet: 'row' }}
      paddingX={{ base: 500, tablet: 700, desktop: 800 }}
      paddingY={700}
      sx={{
        transition: 'background-color 1s ease',
      }}
      width="100%"
      zIndex={{ base: 'sticky', tablet: 'unset' }}
    >
      <CobrandLogo colorMode="light" height={300} width="100%" />
      {isSignup && (
        <Button
          alignSelf="center"
          as="a"
          fill="minimal"
          href={`${Route.SIGN_UP_ONBOARDING.path}/welcome${search}`}
          size="small"
        >
          {t('login')}
        </Button>
      )}
    </Box>
  );
};
